<template>
  <div
    class="filter-drawer"
  >
    <drawer-panel
      :is-opened="isOpened"
      @close="onClose"
    >
      <inner>
        <template #default>
          <panel-filters
            @select="onSelect"
          />
        </template>
        <template #footer>
          <ui-button
            key="clear"
            wide
            secondary
            large
            text="Сбросить"
            class="filter-drawer__button"
            @click="onClear"
          />
          <ui-button
            key="apply"
            wide
            large
            text="Применить"
            class="filter-drawer__button"
            @click="onClose"
          />
        </template>
      </inner>
    </drawer-panel>

    <transition name="slide">
      <sub-panel
        @back="onBack"
        @close="onClose"
        v-if="isSubPanelShown"
        :title="selectedMenuData.name"
      >
        <sort-mobile-menu
          v-if="isSortMenuActivated"
          :value="sort"
          @apply="onSortApply"
        />
        <template v-else>
          <component
            v-if="selectedItemId"
            :is="selectItem"
            :options="selectedMenuOptions"
            :value="getFilterValue(selectedItemId)"
            :name="selectedMenuData.id"
            @apply="onApply"
            @clear="clearAppliedFilter"
          />
        </template>
      </sub-panel>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import {
  SIZE_FILTER_ID,
  COLOR_FILTER_ID,
  PRICE_FILTER_ID,
  DEFAULT_SORT,
} from '@/store/consts';

import DrawerPanel from '@kit/drawer-panel/drawer-panel.vue';
import PanelFilters from '@/components/panel-filters/panel-filters.vue';
import Inner from '@/components/mobile-multiselect/inner.vue';
import SubPanel from '@kit/drawer-panel/sub-panel.vue';
import MobileMultiselectDefault from '@/components/filters/mobile-multiselect-default.vue';
import MobileMultiselectColor from '@/components/filters/mobile-multiselect-color.vue';
import MobileMultiselectSize from '@/components/filters/mobile-multiselect-size.vue';
import MobileSelectPrice from '@/components/filters/mobile-select-price.vue';
import SortMobileMenu from '@/components/filters/sort-mobile-menu.vue';

export default {
  components: {
    DrawerPanel,
    PanelFilters,
    Inner,
    SubPanel,
    MobileMultiselectDefault,
    MobileMultiselectColor,
    MobileMultiselectSize,
    MobileSelectPrice,
    SortMobileMenu,
  },

  props: {
    isOpened: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isSubPanelShown: false,
      selectedItemId: null,
      isSortMenuActivated: false,
    }
  },

  computed: {
    ...mapState('category', ['sort', 'appliedFiltersState', 'filters']),
    ...mapGetters('category', ['getFilterValue', 'getFilter', 'appliedFiltersCount']),

    selectedMenuData() {
      return this.getFilter(this.selectedItemId) || {};
    },
    selectedMenuOptions() {
      if (!this.selectedItemId ) return [];

      return this.selectedMenuData.values;
    },
    submenuTitle() {
      return this.selectedMenuData.title
    },
    selectItem() {
      if (this.selectedItemId === SIZE_FILTER_ID) {
        return MobileMultiselectSize;
      } else if (this.selectedItemId === COLOR_FILTER_ID) {
        return MobileMultiselectColor;
      } else if (this.selectedItemId === PRICE_FILTER_ID) {
        return MobileSelectPrice;
      }

      return MobileMultiselectDefault;
    },
    canBeCleared() {
      return this.appliedFiltersCount > 0 || this.sort !== DEFAULT_SORT;
    },
  },

  methods: {
    ...mapActions('category', [
      'applyCategoryFilter',
      'clearAppliedFilter',
      'clearAllFiltersAndSort',
    ]),

    onSelect(menuItemId) {
      if (menuItemId === 'sort') {
        this.isSortMenuActivated = true;
      } else {
        this.isSortMenuActivated = false;
      }

      this.selectedItemId = menuItemId;
      this.isSubPanelShown = true;
    },
    onBack() {
      this.isSubPanelShown = false;
      this.selectedItemId = null;
    },
    onClose() {
      this.$emit('close');
      this.onBack();
    },
    onApply(filterData) {
      this.applyCategoryFilter({ filterData: [filterData] });
      this.onBack();
    },
    onSortApply(sort){
      this.applyCategoryFilter({ sort });
      this.onBack();
    },
    onClear() {
      if(this.canBeCleared) {
        this.clearAllFiltersAndSort();
      }

      this.onClose();
    }
  }
}
</script>

<style lang="scss">
  .filter-drawer__reset-all-wrap {
    display: flex;
    flex: 1;

    &:last-child {
      margin-right: 8px;
    }
  }

  .filter-drawer__button {
    flex: 1;
  }
</style>